<script setup lang="ts">
  import { ref, watchEffect } from 'vue'
  const props = defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    noDelay: {
      type: Boolean,
      default: false,
    },
  })

  const loadingActive = ref(true)
  const loadingShow = ref(false)
  watchEffect(() => {
    if (props.show === true) {
      loadingActive.value = true
      setTimeout(() => {
        loadingShow.value = true
      }, 1)
    }
    if (props.show === false) {
      setTimeout(
        () => {
          loadingShow.value = false
        },
        props.noDelay ? 1 : 200
      )
      setTimeout(
        () => {
          loadingActive.value = false
        },
        props.noDelay ? 1 : 300
      )
    }
  })
</script>
<template>
  <div class="loading">
    <div class="loading__img" :class="{ loading_active: loadingActive, animateshow: loadingShow }"></div>
    <div class="loading__content" :class="{ loading_active: loadingActive }">
      <slot></slot>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .loading {
    width: 100%;
    position: relative;
  }
  .loading__img {
    width: 100%;
    height: 100%;
    background: url('@/assets/imgs/common/loading.gif') no-repeat center center;
    position: absolute;
    border-radius: 4px;
    display: none;
    opacity: 0;
    transition: opacity 0.3s;
    &.loading_active {
      display: block;
    }
    &.animateshow {
      opacity: 1;
    }
  }

  .loading__content {
    opacity: 1;
    transition: 0.1s opacity;
    &.loading_active {
      pointer-events: none;
      opacity: 0;
    }
  }

  @media #{$tablet} {
  }
</style>
